const mediaItems = [
  {
    title: '触手漫画推荐：不可错过的十大经典',
    desc: '从入门到进阶，为你盘点触手漫画领域最值得一读的十部经典作品。',
    duration: '15:28',
    icon: 'ri-play-circle-line',
    image: 'https://readdy.ai/api/search-image?query=A%20beautifully%20arranged%20flat%20lay%20of%20manga%20volumes%20with%20tentacle%20themed%20covers%2C%20warm%20ambient%20lighting%2C%20artistic%20composition%2C%20coral%20and%20cream%20color%20palette%2C%20cozy%20reading%20nook%20vibe%2C%20professional%20product%20photography%20style&width=600&height=400&seq=media-manga-01&orientation=landscape',
  },
  {
    title: '触手漫画新番速递：本月必看新作',
    desc: '最新上架的触手漫画新作一网打尽，看看本月有哪些值得追的触手漫画。',
    duration: '12:45',
    icon: 'ri-play-circle-line',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20art%20studio%20scene%20with%20sketches%20and%20drawing%20tools%20featuring%20tentacle%20character%20designs%2C%20warm%20desk%20lamp%20lighting%2C%20creative%20atmosphere%2C%20amber%20and%20coral%20tones%2C%20artistic%20workspace%2C%20professional%20photography&width=600&height=400&seq=media-manga-02&orientation=landscape',
  },
  {
    title: '触手漫画解读：世界观与设定分析',
    desc: '深入解析热门触手漫画的世界观构建与独特设定，带你更好地理解触手漫画的魅力。',
    duration: '20:10',
    icon: 'ri-play-circle-line',
    image: 'https://readdy.ai/api/search-image?query=A%20manga%20reader%20holding%20an%20open%20comic%20book%20with%20intricate%20tentacle%20illustrations%2C%20soft%20natural%20window%20light%2C%20cozy%20reading%20atmosphere%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20editorial%20photography%20style&width=600&height=400&seq=media-manga-03&orientation=landscape',
  },
  {
    title: '漫友分享：我最爱的触手漫画推荐',
    desc: '触手漫画社区读者精选分享，看看其他漫友都在追什么触手漫画。',
    duration: '18:32',
    icon: 'ri-play-circle-line',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20group%20of%20friends%20sitting%20together%20reading%20manga%20books%20with%20tentacle%20themed%20illustrations%2C%20cozy%20cafe%20setting%2C%20soft%20afternoon%20light%2C%20coral%20and%20amber%20color%20tones%2C%20lifestyle%20photography%20style&width=600&height=400&seq=media-manga-04&orientation=landscape',
  },
  {
    title: '触手漫画创作：同人作品精选展示',
    desc: '触手漫画同人创作佳作展示，欣赏触手漫画爱好者们的精彩二次创作。',
    duration: '25:15',
    icon: 'ri-play-circle-line',
    image: 'https://readdy.ai/api/search-image?query=An%20artistic%20display%20of%20fan-made%20manga%20illustrations%20featuring%20creative%20tentacle%20designs%2C%20art%20gallery%20wall%20arrangement%2C%20gallery%20lighting%2C%20warm%20amber%20and%20coral%20tones%2C%20exhibition%20photography%20style&width=600&height=400&seq=media-manga-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 scroll-mt-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          漫画视频
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          触手漫画相关的精彩视频内容推荐
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-accent-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - 触手漫画视频`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-background-50/90 backdrop-blur-sm rounded-full text-primary-500 text-2xl group-hover:scale-110 transition-transform">
                    <i className={item.icon}></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-black/60 backdrop-blur-sm rounded text-xs text-background-50 whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-800 mb-1 group-hover:text-accent-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}